import React from "react";
import { useTranslation } from "react-i18next";
import ContributorRow from "../components/ContributorRow";
import "./ModalTheme.css";

export default function VisitorCenterModal(props) {
  const { t } = useTranslation();
  const {
    modalId,
    groupId,
    groupName,
    contributors,
    renderGroup,
    settlements,
    contributorIdDict,
    settlementType,
    setIsLoading,
    isSettled = false,
    isSettling = false,
    settleConfirmModalId,
  } = props;

  const openSettleConfirm = () => {
    if (!settleConfirmModalId || isSettled) return;
    const current = document.getElementById(modalId);
    const target = document.getElementById(settleConfirmModalId);
    if (!target || !window?.bootstrap?.Modal) return;
    try {
      if (current) {
        const inst =
          window.bootstrap.Modal.getInstance(current) ||
          window.bootstrap.Modal.getOrCreateInstance(current);
        inst.hide();
      }
    } catch (e) {
      // ignore
    }
    window.setTimeout(() => {
      try {
        const inst =
          window.bootstrap.Modal.getInstance(target) ||
          window.bootstrap.Modal.getOrCreateInstance(target);
        inst.show();
      } catch (e) {
        // ignore
      }
    }, 150);
  };

  return (
    <div className="modal fade" id={modalId} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div className="modal-content as-modal as-theme">
          <div className="modal-header">
            <div className="as-modal-header-row">
              <div className="as-modal-title-row">
                <span className="as-modal-icon-badge" aria-hidden="true">
                  🏛️
                </span>
                <h5 className="modal-title">
                  {t("group.visitor_center") || "Visitor Center"}
                </h5>
              </div>
              <div className="as-modal-actions">
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
            </div>
          </div>

          <div className="modal-body">
            <ul className="list-group list-group-flush as-row-list">
              {(Array.isArray(contributors) ? contributors : []).map((c) => (
                <li className="list-group-item" key={c.id}>
                  <ContributorRow
                    groupId={groupId}
                    groupName={groupName}
                    contributor={c}
                    renderGroup={renderGroup}
                    settlements={settlements}
                    contributorIdDict={contributorIdDict}
                    settlementType={settlementType}
                    setIsLoading={setIsLoading}
                    isSettled={isSettled}
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-footer as-modal-footer">
            <button type="button" className="btn as-btn-soft" data-bs-dismiss="modal">
              {t("general.close")}
            </button>
            {!isSettled ? (
              <button
                type="button"
                className="btn btn-primary as-btn-primary-gradient"
                onClick={openSettleConfirm}
                disabled={isSettling}
              >
                {isSettling ? (t("group.settling") || "Settling…") : (t("group.settle") || "Settle")}
              </button>
            ) : (
              <button type="button" className="btn as-btn-soft" disabled>
                <i className="bi bi-lock-fill me-1" />
                {t("group.settled") || "Settled"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

